<template>
  <div>
    <div v-if="tokenTransactions.length > 0">
      <b-table
        :data="tokenTransactions"
        class="table"
        v-bind:mobileCards="false"
      >
        <template slot-scope="props">
            <b-table-column field="hash" label="TxHash">
              <div v-if="props.row.hash && props.row.hash.length < 40">
                {{ props.row.hash }}
              </div>
              <router-link
                v-else
                class="router-link short-addr"
                :to="{ name: 'tx', params: {txhash: props.row.hash}}"
              >
                <i v-if="props.row.txStatus === 'Failure'" style="font-style:normal; color:red; margin-right:2px;">&#9432;</i>
                {{ props.row.hash }}
              </router-link>
            </b-table-column>

            <b-table-column field="blockNumber" label="Block">
              <router-link
                class="router-link"
                :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}"
              >
                {{ props.row.blockNumber }}
              </router-link>
            </b-table-column>

            <b-table-column field="timeStamp" label="Age">
              <v-tooltip bottom>
                  <span slot="activator">
                      <timeago
                        :datetime="props.row.timestamp"
                        :auto-update="10">
                      </timeago>
                  </span>
                  <span>{{ new Date(props.row.timestamp).toISOString() }}</span>
                </v-tooltip>
            </b-table-column>

            <b-table-column field="from" label="From">
              <div class="short-addr" v-if="(address === props.row.tokenFrom) || (props.row.tokenFrom.length < 40)">
                {{ props.row.tokenFrom }}
              </div>
              <router-link
                v-else
                class="router-link short-addr"
                :to="{ name: 'address', params: {address: props.row.tokenFrom}}"
              >
                {{ props.row.tokenFrom }}
              </router-link>

            </b-table-column>

            <!-- <b-table-column label="">
              <img
                class="transferIcons"
                v-if="(address == props.row.from) && (props.row.tokenTo)"
                src="@/assets/img/icons/transfer_out_to_right.png"
                alt="transfer out"
              />
              <img
                class="transferIcons"
                v-else-if="(address == props.row.tokenTo)"
                src="@/assets/img/icons/transfer_in_to_left.png"
                alt="transfer in"
              />
            </b-table-column> -->
            <b-table-column label="">
              {{
                props.row.tokenTo
                && (address == props.row.tokenTo)
                ? `IN`
                : (address == props.row.tokenFrom)
                && (props.row.tokenTo)
                ? `OUT`
                : ''
              }}
            </b-table-column>

            <b-table-column field="to" label="To">
              <div v-if="props.row.tokenTo && (props.row.tokenTo !== address)">
                <router-link
                  class="router-link short-addr"
                  :to="{ name: 'address', params: {address: props.row.tokenTo}}"
                >
                  {{ props.row.tokenTo }}
                </router-link>
              </div>
              <div v-else-if="props.row.txType">
                {{ props.row.txType }}
              </div>
              <div class="short-addr" v-else>
                {{ props.row.tokenTo }}
              </div>
            </b-table-column>

            <b-table-column field="value" label="Value">
              {{ props.row.tokenValue ? `${props.row.tokenValue} ${props.row.tokenSymbol}` : props.row.tokenValue }}
            </b-table-column>

            <b-table-column field="value" label="TxFee">
                {{ props.row.txResult ? props.row.txResult.fee.value : "" }}
            </b-table-column>

        </template>
      </b-table>
    </div>
      <Empty v-else/>
      <el-pagination
        small
        background
        @current-page="current_page"
        @current-change="shift"
        @prev-click="shift(current_page-1)"
        @next-click="shift(current_page+1)"
        layout="prev, pager, next"
        :current_page.sync="current_page"
        :pager-count=5
        :page-size="pageSize"
        :total="totalTokenTransactions || 0">
      </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'TokenTransactions',
  props: ['address'],
  components: {
    Empty,
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapGetters(['tokenTransactions', 'totalTokenTransactions']),
  },
  watch: {
    '$route.params.address': function () {
      this.shift(1);
    },
  },
  methods: {
    shift(page) {
      this.$store.dispatch('fetchTokenTransactions', {
        address: this.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
  },
  created() {
    this.shift(1);
  },
};
</script>
